import React, { useEffect, useReducer } from "react";
import s3Reducer from "../reducer/s3";

export const useS3 = ( props ) => {

  // 从metadata里面得到s3相关信息后，调用getShareS3Path来获取的presigned URL
  const [s3State, dispatchS3State] = useReducer(s3Reducer, {
    thumbnail: null,
    slide_overview: null,
  });

  

  return { s3State, dispatchS3State }
}